export const COMP_INFO = {
  NAME: "Supplier Panel",
  TAGLINE: "Come Fly With Us",
  COUNTRY_CODE: "91",
  PHONE1: "9876543210",
  PHONE2: "8976543210",
  HELPLINE1: "1800-234-231",
  HELPLINE2: "1800-322-113",
  EMAIL: "companyemail@gmail.com",
  ADDRESS: "Ruchi Vihar, Vasant Kunj, New Delhi, Delhi 110070",
};

//Login page role selector
export const USER_ROLES = [
  { role: "Supplier", icon: "bi bi-truck", role_code: 1003 },
  { role: "Admin", icon: "bi bi-person-badge", role_code: 1001 },
  //   { role: "Vendor", icon: "bi bi-shop", role_code: 1006 },
  //   { role: "Agent", icon: "bi bi-people", role_code: 1004 },
  //   { role: "Distributor", icon: "bi bi-diagram-3", role_code: 1005 },
];

export const LIGHT_LOGO_URL = "/assets/images/logo/light-logo.png";
export const DARK_LOGO_URL = "/assets/images/logo/dark-logo.png";
export const SITE_COMPANY_NAME = "virtual2Actual Pvt Ltd";
export const SITE_WEBSITE = "https://series-fare.virtualtoactual.cloud/login";
export const SITE_COPYRIGHT = `© ${new Date().getFullYear()} ${SITE_COMPANY_NAME}. All rights reserved.`;
